import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild, AfterViewChecked } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { AppStateService } from '../../services/app-state.service';

@Component({
  selector: 'app-chat',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css'],
})
export class ChatComponent implements OnInit, AfterViewChecked {
  @ViewChild('chatBox') chatBox?: ElementRef<HTMLDivElement>;

  userMessage = '';
  sending = false;

  constructor(public state: AppStateService, private api: ApiService) {}

  ngOnInit(): void {}

  ngAfterViewChecked(): void {
    if (this.chatBox) {
      const el = this.chatBox.nativeElement;
      el.scrollTop = el.scrollHeight;
    }
  }

  send(): void {
    const msg = this.userMessage.trim();
    if (!msg || this.sending) {
      return;
    }
    this.state.addMessage({ role: 'user', content: msg });
    this.userMessage = '';
    this.sending = true;
    this.api.chat(msg, this.state.form(), this.state.activeThreadId()).subscribe({
      next: (result) => {
        this.state.setConversationContext(result.thread_id, result.message_id, result.conversation_id);
        this.state.setForm(result.updated_form);
        this.state.addMessage({ role: 'assistant', content: result.assistant_reply || 'Done.' });
        this.state.refreshConversationThreads();
        this.sending = false;
      },
      error: (err) => {
        this.state.addMessage({ role: 'assistant', content: `⚠️ Chat failed: ${err.message || err}` });
        this.sending = false;
      },
    });
  }

  onKeydown(evt: KeyboardEvent): void {
    if (evt.key === 'Enter' && !evt.shiftKey) {
      evt.preventDefault();
      this.send();
    }
  }
}
